import React, {Component} from 'react';
import classes from './IAIndex.css';
import NumberFormat from 'react-number-format';
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import ToolTip from '../ToolTip/ToolTip';

export class IAIndex extends Component {

    updateData = (key, value) => {
        let data = {
            sp500Minus10Percentage: this.props.sp500Minus10Percentage,
            sp500OneYear50Percentage: this.props.sp500OneYear50Percentage,
            sp500OneYear10Percentage: this.props.sp500OneYear10Percentage,
            sp500SixYear10Percentage: this.props.sp500SixYear10Percentage,
            eafeOneYear50Percenpage: this.props.eafeOneYear50Percenpage,
            eafeOneYear10Percenpage: this.props.eafeOneYear10Percenpage,
            realEstateOneYear50Percentage: this.props.realEstateOneYear50Percentage,
            realEstateOneYear10Percentage: this.props.realEstateOneYear10Percentage,
            spdrOneYear50Percentage: this.props.spdrOneYear50Percentage,
            spdrOneYear10Percentage: this.props.spdrOneYear10Percentage
        };

        data[key] = value;
        this.props.updateIndexAchieverIndex(data);
    };

    render() {

        const isIA = this.props.indexProtector === "INDEX ACHIEVER";

        let totalClass = [classes.IndexAchieverAssets];
        if (this.props.total !== 100.0) {
            totalClass.push(classes.totalWrong);
        }

        return (
            <div className={classes.IndexAchieverIndex}>
                <div className={classes.title}>Available Strategies</div>
                <div className={classes.IndexAchieverAllocations}>
                    <div className={classes.IndexAchieverAssetsGroup}>
                        <div className={classes.IndexAchieverTitles}>
                            <label>
                                S&P 500
                                <ToolTip message="The S&P 500 Index tracks the investment results of an index composed of large-cap equities of the 500 leading companies that captures approximately 80% coverage of available market capitalization." />
                            </label>
                        </div>
                        <div className={classes.IndexAchieverAssets}>
                            <label>
                                1-Year -10% Floor with Cap
                            </label>
                            <NumberFormat
                                value={this.props.sp500Minus10Percentage}
                                onValueChange={(values) => this.updateData("sp500Minus10Percentage", values.value)}
                                onClick={() => this.updateData("sp500Minus10Percentage", "")}
                                onBlur={() => this.updateData("sp500Minus10Percentage", "BLUR")}
                                displayType={'input'}
                                suffix={'%'}
                            />
                        </div>
                        {!isIA && (
                            <div className={classes.IndexAchieverAssets}>
                                <label>
                                    1-Year 50% Downside Participation Rate with Upside Participation Rate
                                </label>
                                <NumberFormat
                                    value={this.props.sp500OneYear50Percentage}
                                    onValueChange={(values) => this.updateData("sp500OneYear50Percentage", values.value)}
                                    onClick={() => this.updateData("sp500OneYear50Percentage", "")}
                                    onBlur={() => this.updateData("sp500OneYear50Percentage", "BLUR")}
                                    displayType={'input'}
                                    suffix={'%'}
                                />
                            </div>
                        )}
                        <div className={classes.IndexAchieverAssets}>
                            <label>
                                1-Year 10% Buffer with Cap
                            </label>
                            <NumberFormat
                                value={this.props.sp500OneYear10Percentage}
                                onValueChange={(values) => this.updateData("sp500OneYear10Percentage", values.value)}
                                onClick={() => this.updateData("sp500OneYear10Percentage", "")}
                                onBlur={() => this.updateData("sp500OneYear10Percentage", "BLUR")}
                                displayType={'input'}
                                suffix={'%'}
                            />
                        </div>
                        {!isIA && (
                            <div className={classes.IndexAchieverAssets}>
                                <label>
                                    6-Year 10% Buffer with Upside Participation Rate
                                </label>
                                <NumberFormat
                                    value={this.props.sp500SixYear10Percentage}
                                    onValueChange={(values) => this.updateData("sp500SixYear10Percentage", values.value)}
                                    onClick={() => this.updateData("sp500SixYear10Percentage", "")}
                                    onBlur={() => this.updateData("sp500SixYear10Percentage", "BLUR")}
                                    displayType={'input'}
                                    suffix={'%'}
                                />
                            </div>
                        )}
                    </div>
                    <div className={classes.IndexAchieverAssetsGroup}>
                        <div className={classes.IndexAchieverTitles}>
                            <label>
                                iShares MSCI EAFE ETF
                                <ToolTip message="The iShares MSCI EAFE ETF tracks the investment results of an index composed of developed market equities, including those in Europe, Australia, Asia and the Far East." />
                            </label>
                        </div>
                        <div className={classes.IndexAchieverAssets}>
                            <label>
                                1-Year 10% Buffer with Cap
                            </label>
                            <NumberFormat
                                value={this.props.eafeOneYear10Percenpage}
                                onValueChange={(values) => this.updateData("eafeOneYear10Percenpage", values.value)}
                                onClick={() => this.updateData("eafeOneYear10Percenpage", "")}
                                onBlur={() => this.updateData("eafeOneYear10Percenpage", "BLUR")}
                                displayType={'input'}
                                suffix={'%'}
                            />
                        </div>
                        {!isIA && (
                            <div className={classes.IndexAchieverAssets}>
                                <label>
                                    1-Year 50% Downside Participation Rate with Upside Participation Rate
                                </label>
                                <NumberFormat
                                    value={this.props.eafeOneYear50Percenpage}
                                    onValueChange={(values) => this.updateData("eafeOneYear50Percenpage", values.value)}
                                    onClick={() => this.updateData("eafeOneYear50Percenpage", "")}
                                    onBlur={() => this.updateData("eafeOneYear50Percenpage", "BLUR")}
                                    displayType={'input'}
                                    suffix={'%'}
                                />
                            </div>
                        )}
                    </div>
                    <div className={classes.IndexAchieverAssetsGroup}>
                        <div className={classes.IndexAchieverTitles}>
                            <label>
                                iShares U.S. Real Estate ETF
                                <ToolTip message="The iShares U.S. Real Estate ETF tracks the investment results of an index composed of U.S. equities in the real estate sector." />
                            </label>
                        </div>
                        <div className={classes.IndexAchieverAssets}>
                            <label>
                                1-Year 10% Buffer with Cap
                            </label>
                            <NumberFormat
                                value={this.props.realEstateOneYear10Percentage}
                                onValueChange={(values) => this.updateData("realEstateOneYear10Percentage", values.value)}
                                onClick={() => this.updateData("realEstateOneYear10Percentage", "")}
                                onBlur={() => this.updateData("realEstateOneYear10Percentage", "BLUR")}
                                displayType={'input'}
                                suffix={'%'}
                            />
                        </div>
                        {!isIA && (
                            <div className={classes.IndexAchieverAssets}>
                                <label>
                                    1-Year 50% Downside Participation Rate with Upside Participation Rate
                                </label>
                                <NumberFormat
                                    value={this.props.realEstateOneYear50Percentage}
                                    onValueChange={(values) => this.updateData("realEstateOneYear50Percentage", values.value)}
                                    onClick={() => this.updateData("realEstateOneYear50Percentage", "")}
                                    onBlur={() => this.updateData("realEstateOneYear50Percentage", "BLUR")}
                                    displayType={'input'}
                                    suffix={'%'}
                                />
                            </div>
                        )}
                    </div>
                    <div className={classes.IndexAchieverAssetsGroup}>
                        <div className={classes.IndexAchieverTitles}>
                            <label>
                                SPDR Gold Shares ETF
                                <ToolTip message="The SPDR Gold Shares ETF is designed to reflect the market value of gold bullion." />
                            </label>
                        </div>
                        <div className={classes.IndexAchieverAssets}>
                            <label>
                                1-Year 10% Buffer with Cap
                            </label>
                            <NumberFormat
                                value={this.props.spdrOneYear10Percentage}
                                onValueChange={(values) => this.updateData("spdrOneYear10Percentage", values.value)}
                                onClick={() => this.updateData("spdrOneYear10Percentage", "")}
                                onBlur={() => this.updateData("spdrOneYear10Percentage", "BLUR")}
                                displayType={'input'}
                                suffix={'%'}
                            />
                        </div>
                        {!isIA && (
                            <div className={classes.IndexAchieverAssets}>
                                <label>
                                    1-Year 50% Downside Participation Rate with Upside Participation Rate
                                </label>
                                <NumberFormat
                                    value={this.props.spdrOneYear50Percentage}
                                    onValueChange={(values) => this.updateData("spdrOneYear50Percentage", values.value)}
                                    onClick={() => this.updateData("spdrOneYear50Percentage", "")}
                                    onBlur={() => this.updateData("spdrOneYear50Percentage", "BLUR")}
                                    displayType={'input'}
                                    suffix={'%'}
                                />
                            </div>
                        )}
                    </div>
                    <div className={totalClass.join(" ")}>
                        <label>Total</label>
                        <NumberFormat
                            value={this.props.total}
                            displayType={'text'}
                            suffix={'%'}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sp500Minus10Percentage: state.planInfo.IndexAchiever.indexAllocation.sp500Minus10Percentage,
        sp500OneYear50Percentage: state.planInfo.IndexAchiever.indexAllocation.sp500OneYear50Percentage,
        sp500OneYear10Percentage: state.planInfo.IndexAchiever.indexAllocation.sp500OneYear10Percentage,
        sp500SixYear10Percentage: state.planInfo.IndexAchiever.indexAllocation.sp500SixYear10Percentage,
        eafeOneYear50Percenpage: state.planInfo.IndexAchiever.indexAllocation.eafeOneYear50Percenpage,
        eafeOneYear10Percenpage: state.planInfo.IndexAchiever.indexAllocation.eafeOneYear10Percenpage,
        realEstateOneYear50Percentage: state.planInfo.IndexAchiever.indexAllocation.realEstateOneYear50Percentage,
        realEstateOneYear10Percentage: state.planInfo.IndexAchiever.indexAllocation.realEstateOneYear10Percentage,
        spdrOneYear50Percentage: state.planInfo.IndexAchiever.indexAllocation.spdrOneYear50Percentage,
        spdrOneYear10Percentage: state.planInfo.IndexAchiever.indexAllocation.spdrOneYear10Percentage,
        total: state.planInfo.IndexAchiever.indexAllocation.total,
        companyName: state.globalState.companyName,
        indexProtector: state.globalState.indexProtector
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateIndexAchieverIndex: (data) => dispatch({type: actionTypes.UPDATE_INDEX_ALLOCATIONS_RILA, data: data})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(IAIndex);


// WEBPACK FOOTER //
// ./src/containers/IAIndex/IAIndex.js